import { defaults } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import {
  PDF_PAGE_DEFAULT_HEIGHT,
  PDF_PAGE_DEFAULT_WIDTH,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { FLAGS } from '../../../../services/flags.service';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class PDFConfigurations extends BoardItemConfig {
  name: string;
  url?: string;
  contentId: string;
  // Indicating that the stacking order have been manipulated after the item was migrated from HTML to fabric
  migratedFromHtmlToFabric: boolean;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: PDF_PAGE_DEFAULT_WIDTH,
    height: PDF_PAGE_DEFAULT_HEIGHT,
    locked: true,
  };

  constructor(
    configurations: Partial<PDFConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...PDFConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultPDFConfigurations = { name: 'untitled.pdf', contentId: uuidv4() };

    const pdfConfigurations = defaults(configurations, defaultPDFConfigurations);

    this.url = pdfConfigurations.url;
    this.name = pdfConfigurations.name;
    this.contentId = pdfConfigurations.contentId;
    this.migratedFromHtmlToFabric =
      pdfConfigurations.migratedFromHtmlToFabric ||
      (globalCreationParams.isNewlyCreatedItem &&
        globalCreationParams.featureFlagsService.isFlagEnabled(FLAGS.RENDER_PDFS_IN_FABRIC));
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): PDFConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      PDFConfigurations.defaultBoardItemConfigurations,
    );
    return new PDFConfigurations(
      {
        ...configurations,
        url: frameItem.resource_state?.resource_url,
        name: frameItem.resource_state?.resource_name,
        contentId: frameItem.content_id,
        migratedFromHtmlToFabric: frameItem.migratedFromHtmlToFabric,
      },
      globalCreationsParams,
    );
  }
}
